

<div class="container-fluid">
    <div class="row top10 no-gutters">
        <div class="col-xs-12 col-md-6 vcenter">
            <h3>Checklist Questions</h3>
        </div>
    </div>

    <hr style="margin-top:5px;margin-bottom:5px;" />

    <div class="row top10">
      <aims-common-table
        id="question-table"
        [dataSource]="questions | async"
        [addRowInitialObject]="defaultQuestion"
        [header]="questionTableHeader"
        [permissions]="questionTablePermissions"
        [stickyHeader]="true"
        (rowUpdated)="handleRowUpdate($event)"
        (rowAdded)="handleRowAdded($event)"
        (rowDeleted)="handleRowDelete($event)"
      >

      <aims-common-table-dynamic-row id="question">
        <ng-template viewMode let-element >
          <quill-view name="question" [content]="element.question" ></quill-view>
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl">
          <quill-editor name="question" [(ngModel)]="element.question" [modules]="modules"  [formControl]="dynamicControl"> </quill-editor>
        </ng-template>
      </aims-common-table-dynamic-row>

       <aims-common-table-dynamic-row id="pubReferenceId">
        <ng-template viewMode let-element >
          {{ element.pubReferenceId | getText:'publicationId':'pubNum':pubValues | async }}
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl">
          <aims-lookup
            name="pubRefLookup"
            [gridText]="'Select a Publication Ref'"
            id="pubRefLookup"
            [values]="pubValues | async"
            [idPropertyName]="'publicationId'"
            [displayPropertyName]="'pubNum'"
            [(ngModel)]="element.pubReferenceId"
            [columnsInGrid]="publicationLookupColumns"
            style="width:100%">
          </aims-lookup>
        </ng-template>

        <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
          <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
            <mat-label>Filter</mat-label>
            <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
              <mat-option label=""></mat-option>
              <mat-option *ngFor="let p of pubValues | async" [value]="p.publicationId">
                {{ p.pubNum }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="responsibleAssignmentId">
        <ng-template viewMode let-element >
            {{ element.responsibleAssignmentId | getText:'responsibleAssignmentId':'responsibleAssignment':responsibleAssignmentValues | async }}
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl">
          <aims-lookup
            name="responsibleAssignmentLookup"
            [gridText]="'Select a Responsible Manager'"
            id="responsibleAssignmentLookup"
            [values]="responsibleAssignmentValues | async"
            [idPropertyName]="'responsibleAssignmentId'"
            [displayPropertyName]="'responsibleAssignment'"
            [(ngModel)]="element.responsibleAssignmentId"
            [columnsInGrid]="responsibleAssignmentLookupColumns"
            style="width:100%">
          </aims-lookup>
        </ng-template>

        <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
          <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
            <mat-label>Filter</mat-label>
            <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
              <mat-option label=""></mat-option>
              <mat-option *ngFor="let r of responsibleAssignmentValues | async" [value]="r.responsibleAssignmentId">
                {{ r.responsibleAssignment }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-template>
      </aims-common-table-dynamic-row>

      <ng-template aimsCommonTableExpandedRow let-element >
        <div class="row">
          <div class="col-xs-12">
            <button *ngIf="permissions.canUpdate(permissions.ComponentID.QcChecklists)" class="btn btn-danger"
                (click)="saveRow(element,sitesSel.options,areasSel.options)">Save
                Changes</button>
          </div>
          <div class="col-xs-12 col-lg-6">
            <div class="row">
              <div class="col-xs-12">
                  <b>Sites:</b>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                  <select name="sites" style="width:100%" [attr.size]="(siteValues | async).length + 1"
                      multiple #sitesSel>
                      <option value="null" [selected]="element.sites == null">
                          All
                      </option>
                      <option *ngFor="let site of siteValues | async" [value]="site.siteId"
                          [selected]="element.sites != null && element.sites.split(',').indexOf(site.siteId.toString()) != -1">
                          {{site.siteName}}
                      </option>
                    </select>
                </div>
            </div>
          </div>

          <div class="col-xs-12 col-lg-6">
            <div class="row">
                <div class="col-xs-12">
                    <b>Areas:</b>
                </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <select name="areas" style="width:100%" [attr.size]="(areaValues | async).length + 1"
                      multiple #areasSel>
                      <option value="null" [selected]="element.areas == null">
                          All
                      </option>
                      <option *ngFor="let area of areaValues | async" [value]="area.areaId"
                          [selected]="element.areas != null && element.areas.split(',').indexOf(area.areaId.toString()) != -1">
                          {{area.area}}
                      </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </aims-common-table>

    <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
  </div>
</div>
